import { BackLink } from "..";
import Missing, { IMissingProps } from "./missing";
import { IBackLinkProps } from "../backLink/backLink";
import { brand } from "../../../config/brand";

const RecordMissing = ({
  back = {
    title: `Back to ${brand.shortName}`,
    path: "/",
  },
  children,
  message,
  type = "record",
  ...otherProps
}: IRecordMissingProps) => {
  return (
    <Missing
      title={`Sorry, we can’t find that ${type}`}
      message={message}
      {...otherProps}
    >
      {children ? children : <BackLink title={back.title} path={back.path} />}
    </Missing>
  );
};

interface IRecordMissingProps extends IMissingProps {
  back?: IBackLinkProps;
}

export default RecordMissing;
